//项目名称
// export const PROJECTNAME="/zqyl-web";
// export const PROJECTNAME="";

export const LOADING={
    lock: true,
    text: 'Loading',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
};
//状态码
export const STATUSCODE={
    code01:'M0200',
    code02:'M0300',
    code03:'M0500',
    code04:'M0400',
};
//IE9路由地址不修改 跳转不生效
export const RELOAD=function(){
    if(navigator.userAgent.indexOf("MSIE 9.0") !== -1){
        location.reload();
    }    
};
//今天及今天之前
export const afterToday={
    disabledDate(time){
        return time.getTime() < Date.now() - 8.64e7;
    }
};
export const pickerOptions = {
    shortcuts: [{
        text: '最近一个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近三个月',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近半年',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '最近一年',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            start.setTime(start.getTime() - 3600 * 1000 * 24 * 360);
            picker.$emit('pick', [start, end]);
        }
    }, {
        text: '无固定期限',
        onClick(picker) {
            const end = new Date();
            const start = new Date();
            end.setTime(4070880000000);
            picker.$emit('pick', [start, end]);
        }
    }]
};